import { Container, Typography } from "@mui/material";

export function ContentRendererTitle(block: any) {
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Typography variant={block.variant || "h2"} align={block.align || "center"}>
        {block.text}
      </Typography>
    </Container>
  );
}
